import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Clock } from "../../../../assets/icons/Clock.js";
import { CallTaskState } from "../../../../call-management.types.js";
import "react/jsx-runtime";
const TextWrapper = styled("span")(() => ({
  display: "flex",
  alignItems: "center"
}));
const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isLate" && prop !== "status"
})(({ theme, status, isLate }) => ({
  color: theme.palette.grey[600],
  ...isLate && status === CallTaskState.Open && {
    color: theme.palette.error[500]
  },
  ...(status === CallTaskState.Ignored || status === CallTaskState.Done || status === CallTaskState.Done_AvailyBooking) && {
    color: theme.palette.highlight1[600]
  }
}));
const ClockIcon = styled(Clock)(({ theme }) => ({
  color: theme.palette.grey[500],
  marginLeft: "4px",
  marginBottom: "1px",
  width: "16px",
  height: "16px"
}));
export {
  ClockIcon,
  StyledTypography,
  TextWrapper
};
